import type { RouteRecordRaw } from 'vue-router'

import CatalogView from '@/modules/catalog/views/CatalogView.vue'
import ProductView from '@/modules/catalog/views/ProductView.vue'

export const catalogRoutes: RouteRecordRaw[] = [
  {
    path: '/catalog',
    name: 'catalog',
    component: CatalogView,
    meta: {
      title: 'Каталог оборудования и материалов',
      description:
        'Каталог оборудования и материалов в ЛабАктив: аналитические приборы, микроскопы, хроматографы, расходные материалы и другие позиции для бизнеса.',
      canonicalQuery: ['category', 'manufacturer'],
      ogType: 'website',
    },
  },
  {
    path: '/product/:id',
    name: 'product',
    component: ProductView,
    meta: {
      title: 'Карточка товара',
      description:
        'Карточка товара в каталоге ЛабАктив: характеристики, изображения, наличие и данные по оборудованию и материалам.',
      ogType: 'product',
    },
    props: true,
  },
]
